import BarangJadiApi from './BarangJadiApi';

export default BarangJadiApi;
